import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {toggleHideItemsSwitcher} from "../../actions/actionFunctions";
import Analytics from "../../analytics";
import {getShowPrice} from "../../misc/priceFunctions";

const HideItemsSwitcher = (props) => {

  const {fabricatorData, toggleHideItemsSwitcher} = props;

  if (!document.kvConfig.isBackend || !fabricatorData.showCheckoutLineItemPricesToggle) {
    return null
  }

  const showPrices = getShowPrice(fabricatorData);

  const handleButtonClick = () => {
    Analytics.sendClickEvent(`toggle-show-prices-${!showPrices ? "on" : "off"}`);
    toggleHideItemsSwitcher();
  };

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label"><FormattedMessage id="header.togglePricesCheckbox"/></span>
      <button className={"ui-radio ui-radio--small" + (showPrices ? " ui-radio--checked" : "")}
              onClick={handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData,
  };
};

const mapDispatchToProps = {
  toggleHideItemsSwitcher,
};

export default connect(mapStateToProps, mapDispatchToProps)(HideItemsSwitcher);
